import React from 'react';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import EditIcon from '@material-ui/icons/Edit';
import { Tooltip, withStyles } from '@material-ui/core';
import SearchBox from '../../../../common/SearchBox';

const styles = (theme) => ({
  container: {
    width: '100%',
    maxWidth: 720,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  headerIconStyles: {
    padding: '5px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
    float: 'right',
    display: 'flex',
    alignItems: 'center',
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  disableIcon: {
    cursor: 'not-allowed',
    opacity: 0.7
  },
  enableIcon: {
    cursor: 'pointer'
  }
});

const GridHeader = ({
  classes,
  isAddUpdateDrawerOpen,
  selectedTrailers,
  openSideDrawer,
  hasAdminAccess,
  updateSearchText
}) => {
  const getIconTitle = (params) => {
    const { iconName, isAddUpdateDrawerOpen, disableEditIcon } = params;
    if (isAddUpdateDrawerOpen) {
      return 'Add/update in progress';
    }
    switch (iconName) {
      case 'editIcon':
        if (disableEditIcon) {
          return 'Select a row to edit';
        } else {
          return 'Click to edit';
        }
      case 'addIcon':
        return 'Click to add';
      default:
        return '';
    }
  };

  const disableAddIcon = isAddUpdateDrawerOpen;
  const disableEditIcon = !selectedTrailers?.length || isAddUpdateDrawerOpen;

  const params = {
    isAddUpdateDrawerOpen,
    disableEditIcon,
    disableAddIcon
  };

  const openDrawerHandler = (isUpdate) => () => {
    openSideDrawer(isUpdate);
  };

  return (
    <div className={classes.container}>
      <SearchBox onChange={updateSearchText} />
      {hasAdminAccess() && (
        <>
          <span
            className={`${classes.headerIconStyles} ${
              disableAddIcon ? classes.disableIcon : classes.enableIcon
            }`}
            onClick={disableAddIcon ? null : openDrawerHandler(false)}>
            <Tooltip title={getIconTitle({ iconName: 'addIcon', ...params })}>
              <AddRoundedIcon />
            </Tooltip>
          </span>
          <span
            className={`${classes.headerIconStyles} ${
              disableEditIcon ? classes.disableIcon : classes.enableIcon
            }`}
            onClick={disableEditIcon ? null : openDrawerHandler(true)}>
            <Tooltip title={getIconTitle({ iconName: 'editIcon', ...params })}>
              <EditIcon />
            </Tooltip>
          </span>
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(GridHeader);
